import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'login',
        loadChildren: './views/login/login.module#LoginModule'
      },
      {
        path: 'profile',
        loadChildren: './views/profile/profile.module#ProfileModule'
      },
      {
        path: 'forgot/password',
        loadChildren: './views/forgotPassword/forgot-password.module#ForgotPasswordModule'
      },
      {
        path: 'reset/password',
        loadChildren: './views/reset-password/reset-password.module#ResetPasswordModule'
      },
      {
        path: 'active/lead',
        loadChildren:'./views/active-lead/active-lead.module#ActiveLeadModule'
      },
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'admin/dashboard',
        loadChildren: './views/admin-dashboard/admin-dashboard.module#AdminDashboardModule'
      },
      {
        path: 'lead',
        loadChildren: './views/lead/lead.module#LeadModule'
      },
      {
        path: 'assign_product',
        loadChildren: './views/assign-product/assign-product.module#AssignProductModule'
      },
      {
        path: 'product',
        loadChildren: './views/product/product.module#ProductModule'
      },
      {
        path: 'user',
        loadChildren: './views/users/manage-user.module#ManageUserModule'
      },
      {
        path: 'components',
        loadChildren: './views/components/components.module#ComponentsModule'
      },
      {
        path: 'role',
        loadChildren: './views/role/role.module#RoleModule'
      },
      {
        path: 'city',
        loadChildren: './views/city/city.module#CityModule'
      },
      {
        path: 'product-sales-history',
        loadChildren:'./views/product-sales-history/product-sales-history.module#ProductSalesHistoryModule'
      },
      {
        path: 'payment-collection',
        loadChildren:'./views/payment-collection/payment-collection.module#PaymentCollectionModule'
      },
      {
        path: 'payment-deposition',
        loadChildren:'./views/payment-deposition/payment-deposition.module#PaymentDepositionModule'
      },
      {
        path: 'assignment',
        loadChildren: './views/assignment/assignment.module#AssignmentModule'
      },
      {
        path: 'areaManagement',
        loadChildren: './views/area-management/area-management.module#AreaManagementModule'
      },
      {
        path: 'leadActivity',
        loadChildren: './views/lead-activity/lead-activity.module#LeadActivityModule'
      },
      {
        path: 'assignmentActivity',
        loadChildren: './views/assignment-activity/assignment-activity.module#AssignmentActivityModule'
      },
      {
        path: 'holiday',
        loadChildren: './views/holiday/holiday.module#HolidayModule'
      },
      {
        path: 'goal',
        loadChildren: './views/goal/goal.module#GoalModule'
      },
      {
        path: 'changeOwner',
        loadChildren: './views/change-owner/change-owner.module#ChangeOwnerModule'
      },
      {
        path: 'adminReport',
        loadChildren: './views/admin-report/admin-report.module#AdminReportModule'
      },
      {
        path: 'complainmanagement',
        loadChildren: './views/complain-management/complain-management.module#ComplainManagementModule'
      },
      {
        path: '',
        loadChildren: './shared/shared.module#SharedModule'
      },
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/app.routing.ts